"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6412],{

/***/ 84091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ SkeletonV2; },
  "Z": function() { return /* binding */ Skeleton_Skeleton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 23 modules
var motion_minimal = __webpack_require__(45962);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/LazyMotion/index.mjs
var LazyMotion = __webpack_require__(18522);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/features-animation.mjs + 27 modules
var features_animation = __webpack_require__(55606);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Skeleton/types.ts
var types_animation = {
    WAVES: "waves",
    PULSE: "pulse"
};
var types_variant = {
    RECT: "rect",
    CIRCLE: "circle"
};

// EXTERNAL MODULE: ./packages/uikit/src/util/animationToolkit.ts
var animationToolkit = __webpack_require__(98903);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n   from {\n        left: -150px;\n    }\n    to   {\n        left: 100%;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  will-change: opacity;\n  opacity: 0;\n  &.appear {\n    animation: ",
        " 0.3s ease-in-out forwards;\n  }\n  &.disappear {\n    animation: ",
        " 0.3s ease-in-out forwards;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  ",
        "\n  ",
        "\n  overflow: hidden;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 20px;\n  display: block;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 2s infinite ease-out;\n  transform: translate3d(0, 0, 0);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  overflow: hidden;\n  transform: translate3d(0, 0, 0);\n  &:before {\n    content: "";\n    position: absolute;\n    background-image: linear-gradient(90deg, transparent, rgba(243, 243, 243, 0.5), transparent);\n    top: 0;\n    left: -150px;\n    height: 100%;\n    width: 150px;\n    animation: ',
        " 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







var waves = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var pulse = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
var AnimationWrapper = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div).withConfig({
    componentId: "sc-94de765-0"
}).withConfig({
    componentId: "sc-bfc8af08-0"
})(_templateObject2(), animationToolkit/* appearAnimation */.Oz, animationToolkit/* disappearAnimation */.a4);
var SkeletonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94de765-1"
}).withConfig({
    componentId: "sc-bfc8af08-1"
})(_templateObject3(), index_esm/* layout */.bK, index_esm/* space */.Dh);
var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94de765-2"
}).withConfig({
    componentId: "sc-bfc8af08-2"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
}, function(param) {
    var variant = param.variant, theme = param.theme;
    return variant === types_variant.CIRCLE ? theme.radii.circle : theme.radii.small;
}, index_esm/* layout */.bK, index_esm/* space */.Dh, index_esm/* borderRadius */.E0);
var Pulse = (0,styled_components_browser_esm/* default */.ZP)(Root).withConfig({
    componentId: "sc-94de765-3"
}).withConfig({
    componentId: "sc-bfc8af08-3"
})(_templateObject5(), pulse);
var Waves = (0,styled_components_browser_esm/* default */.ZP)(Root).withConfig({
    componentId: "sc-94de765-4"
}).withConfig({
    componentId: "sc-bfc8af08-4"
})(_templateObject6(), waves);
var Skeleton = function Skeleton(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? types_variant.RECT : _variant, _animation = _param.animation, animation = _animation === void 0 ? types_animation.PULSE : _animation, props = (0,_object_without_properties/* default */.Z)(_param, [
        "variant",
        "animation"
    ]);
    if (animation === types_animation.WAVES) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Waves, (0,_object_spread/* default */.Z)({
            variant: variant
        }, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pulse, (0,_object_spread/* default */.Z)({
        variant: variant
    }, props));
};
var SkeletonV2 = function SkeletonV2(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? types_variant.RECT : _variant, _animation = _param.animation, animation = _animation === void 0 ? types_animation.PULSE : _animation, _isDataReady = _param.isDataReady, isDataReady = _isDataReady === void 0 ? false : _isDataReady, children = _param.children, wrapperProps = _param.wrapperProps, _skeletonTop = _param.skeletonTop, skeletonTop = _skeletonTop === void 0 ? "0" : _skeletonTop, _skeletonLeft = _param.skeletonLeft, skeletonLeft = _skeletonLeft === void 0 ? "0" : _skeletonLeft, width = _param.width, height = _param.height, mr = _param.mr, ml = _param.ml, props = (0,_object_without_properties/* default */.Z)(_param, [
        "variant",
        "animation",
        "isDataReady",
        "children",
        "wrapperProps",
        "skeletonTop",
        "skeletonLeft",
        "width",
        "height",
        "mr",
        "ml"
    ]);
    var animationRef = (0,react.useRef)(null);
    var skeletonRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: width,
        height: height,
        mr: mr,
        ml: ml
    }, wrapperProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMotion/* LazyMotion */.X, {
            features: features_animation/* domAnimation */.H,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnimatePresence/* AnimatePresence */.M, {
                children: [
                    isDataReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimationWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        ref: animationRef,
                        onAnimationStart: function onAnimationStart() {
                            return (0,animationToolkit/* animationHandler */.BI)(animationRef.current);
                        }
                    }, animationToolkit/* animationMap */.Gc), {
                        variants: animationToolkit/* animationVariants */.ji,
                        transition: {
                            duration: 0.3
                        },
                        children: children
                    }), "content"),
                    !isDataReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimationWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        style: {
                            position: "absolute",
                            top: skeletonTop,
                            left: skeletonLeft
                        },
                        ref: skeletonRef,
                        onAnimationStart: function onAnimationStart() {
                            return (0,animationToolkit/* animationHandler */.BI)(skeletonRef.current);
                        }
                    }, animationToolkit/* animationMap */.Gc), {
                        variants: animationToolkit/* animationVariants */.ji,
                        transition: {
                            duration: 0.3
                        },
                        children: animation === types_animation.WAVES ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Waves, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            variant: variant
                        }, props), {
                            width: width,
                            height: height
                        })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Pulse, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            variant: variant
                        }, props), {
                            width: width,
                            height: height
                        }))
                    }), "skeleton")
                ]
            })
        })
    }));
};
/* harmony default export */ var Skeleton_Skeleton = (Skeleton);


/***/ }),

/***/ 16863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5 13H16.17L11.29 17.88C10.9 18.27 10.9 18.91 11.29 19.3C11.68 19.69 12.31 19.69 12.7 19.3L19.29 12.71C19.68 12.32 19.68 11.69 19.29 11.3L12.71 4.7C12.32 4.31 11.69 4.31 11.3 4.7C10.91 5.09 10.91 5.72 11.3 6.11L16.17 11H5C4.45 11 4 11.45 4 12C4 12.55 4.45 13 5 13Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 53985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "KX": function() { return /* binding */ useAddPoolKeys; },
  "Mn": function() { return /* binding */ useAddTokenKeys; },
  "JX": function() { return /* binding */ useAllPoolData; },
  "jv": function() { return /* binding */ useAllTokenData; },
  "lR": function() { return /* binding */ usePoolChartData; },
  "zV": function() { return /* binding */ usePoolDatas; },
  "j8": function() { return /* binding */ usePoolTransactions; },
  "B5": function() { return /* binding */ useProtocolChartData; },
  "rf": function() { return /* binding */ useProtocolData; },
  "Wz": function() { return /* binding */ useProtocolTransactions; },
  "_n": function() { return /* binding */ useTokenDatas; },
  "b0": function() { return /* binding */ useUpdatePoolData; },
  "pV": function() { return /* binding */ useUpdateTokenData; }
});

// UNUSED EXPORTS: usePoolsForToken, useTokenChartData, useTokenData, useTokenPriceData, useTokenTransactions

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/state/index.ts + 38 modules
var state = __webpack_require__(25099);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./src/utils/graphql.ts
var graphql = __webpack_require__(75509);
// EXTERNAL MODULE: ./src/config/constants/info.ts
var info = __webpack_require__(4003);
// EXTERNAL MODULE: ./src/state/info/queries/helpers.ts
var helpers = __webpack_require__(74472);
;// CONCATENATED MODULE: ./src/state/info/queries/pools/chartData.ts



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query pairDayDatas($startTime: Int!, $skip: Int!, $address: Bytes!) {\n        pairDayDatas(\n          first: 1000\n          skip: $skip\n          where: { pairAddress: $address, date_gt: $startTime }\n          orderBy: date\n          orderDirection: asc\n        ) {\n          date\n          dailyVolumeUSD\n          reserveUSD\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var getPoolChartData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(skip, address) {
        var query, pairDayDatas, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    query = (0,dist.gql)(_templateObject());
                    _ctx.next = 4;
                    return graphql/* infoClient.request */.dQ.request(query, {
                        startTime: info/* PCS_V2_START */.Rr,
                        skip: skip,
                        address: address
                    });
                case 4:
                    pairDayDatas = _ctx.sent.pairDayDatas;
                    data = pairDayDatas.map(helpers/* mapPairDayData */.Iq);
                    return _ctx.abrupt("return", {
                        data: data,
                        error: false
                    });
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Failed to fetch pool chart data", _ctx.t0);
                    return _ctx.abrupt("return", {
                        error: true
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return function getPoolChartData(skip, address) {
        return _ref.apply(this, arguments);
    };
}();
var fetchPoolChartData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(address) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,helpers/* fetchChartData */.Hr)(getPoolChartData, address));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchPoolChartData(address) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var pools_chartData = (fetchPoolChartData);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/state/info/queries/pools/transactions.ts




function transactions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query poolTransactions($address: Bytes!) {\n    mints(first: 35, orderBy: timestamp, orderDirection: desc, where: { pair: $address }) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      to\n      amount0\n      amount1\n      amountUSD\n    }\n    swaps(first: 35, orderBy: timestamp, orderDirection: desc, where: { pair: $address }) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      from\n      amount0In\n      amount1In\n      amount0Out\n      amount1Out\n      amountUSD\n    }\n    burns(first: 35, orderBy: timestamp, orderDirection: desc, where: { pair: $address }) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      sender\n      amount0\n      amount1\n      amountUSD\n    }\n  }\n"
    ]);
    transactions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * Transactions of the given pool, used on Pool page
 */ var POOL_TRANSACTIONS = (0,dist.gql)(transactions_templateObject());
var fetchPoolTransactions = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(address) {
        var data, mints, burns, swaps;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return graphql/* infoClient.request */.dQ.request(POOL_TRANSACTIONS, {
                        address: address
                    });
                case 3:
                    data = _ctx.sent;
                    mints = data.mints.map(helpers/* mapMints */.k9);
                    burns = data.burns.map(helpers/* mapBurns */._h);
                    swaps = data.swaps.map(helpers/* mapSwaps */.H_);
                    return _ctx.abrupt("return", {
                        data: (0,_to_consumable_array/* default */.Z)(mints).concat((0,_to_consumable_array/* default */.Z)(burns), (0,_to_consumable_array/* default */.Z)(swaps)),
                        error: false
                    });
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Failed to fetch transactions for pool ".concat(address), _ctx.t0);
                    return _ctx.abrupt("return", {
                        error: true
                    });
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }));
    return function fetchPoolTransactions(address) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var pools_transactions = (fetchPoolTransactions);

;// CONCATENATED MODULE: ./src/state/info/queries/tokens/chartData.ts



function chartData_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query tokenDayDatas($startTime: Int!, $skip: Int!, $address: Bytes!) {\n        tokenDayDatas(\n          first: 1000\n          skip: $skip\n          where: { token: $address, date_gt: $startTime }\n          orderBy: date\n          orderDirection: asc\n        ) {\n          date\n          dailyVolumeUSD\n          totalLiquidityUSD\n        }\n      }\n    "
    ]);
    chartData_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var getTokenChartData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(skip, address) {
        var query, tokenDayDatas, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    query = (0,dist.gql)(chartData_templateObject());
                    _ctx.next = 4;
                    return graphql/* infoClient.request */.dQ.request(query, {
                        startTime: info/* PCS_V2_START */.Rr,
                        skip: skip,
                        address: address
                    });
                case 4:
                    tokenDayDatas = _ctx.sent.tokenDayDatas;
                    data = tokenDayDatas.map(helpers/* mapDayData */.v5);
                    return _ctx.abrupt("return", {
                        data: data,
                        error: false
                    });
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Failed to fetch token chart data", _ctx.t0);
                    return _ctx.abrupt("return", {
                        error: true
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return function getTokenChartData(skip, address) {
        return _ref.apply(this, arguments);
    };
}();
var chartData_fetchTokenChartData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(address) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,helpers/* fetchChartData */.Hr)(getTokenChartData, address));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchTokenChartData(address) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var chartData = ((/* unused pure expression or super */ null && (chartData_fetchTokenChartData)));

;// CONCATENATED MODULE: ./src/state/info/queries/tokens/transactions.ts




function tokens_transactions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query tokenTransactions($address: Bytes!) {\n    mintsAs0: mints(first: 10, orderBy: timestamp, orderDirection: desc, where: { token0: $address }) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      to\n      amount0\n      amount1\n      amountUSD\n    }\n    mintsAs1: mints(first: 10, orderBy: timestamp, orderDirection: desc, where: { token1: $address }) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      to\n      amount0\n      amount1\n      amountUSD\n    }\n    swapsAs0: swaps(first: 10, orderBy: timestamp, orderDirection: desc, where: { token0: $address }) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      from\n      amount0In\n      amount1In\n      amount0Out\n      amount1Out\n      amountUSD\n    }\n    swapsAs1: swaps(first: 10, orderBy: timestamp, orderDirection: desc, where: { token1: $address }) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      from\n      amount0In\n      amount1In\n      amount0Out\n      amount1Out\n      amountUSD\n    }\n    burnsAs0: burns(first: 10, orderBy: timestamp, orderDirection: desc, where: { token0: $address }) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      sender\n      amount0\n      amount1\n      amountUSD\n    }\n    burnsAs1: burns(first: 10, orderBy: timestamp, orderDirection: desc, where: { token1: $address }) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      sender\n      amount0\n      amount1\n      amountUSD\n    }\n  }\n"
    ]);
    tokens_transactions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * Data to display transaction table on Token page
 */ var TOKEN_TRANSACTIONS = (0,dist.gql)(tokens_transactions_templateObject());
var transactions_fetchTokenTransactions = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(address) {
        var data, mints0, mints1, burns0, burns1, swaps0, swaps1;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return graphql/* infoClient.request */.dQ.request(TOKEN_TRANSACTIONS, {
                        address: address
                    });
                case 3:
                    data = _ctx.sent;
                    mints0 = data.mintsAs0.map(helpers/* mapMints */.k9);
                    mints1 = data.mintsAs1.map(helpers/* mapMints */.k9);
                    burns0 = data.burnsAs0.map(helpers/* mapBurns */._h);
                    burns1 = data.burnsAs1.map(helpers/* mapBurns */._h);
                    swaps0 = data.swapsAs0.map(helpers/* mapSwaps */.H_);
                    swaps1 = data.swapsAs1.map(helpers/* mapSwaps */.H_);
                    return _ctx.abrupt("return", {
                        data: (0,_to_consumable_array/* default */.Z)(mints0).concat((0,_to_consumable_array/* default */.Z)(mints1), (0,_to_consumable_array/* default */.Z)(burns0), (0,_to_consumable_array/* default */.Z)(burns1), (0,_to_consumable_array/* default */.Z)(swaps0), (0,_to_consumable_array/* default */.Z)(swaps1)),
                        error: false
                    });
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Failed to fetch transactions for token ".concat(address), _ctx.t0);
                    return _ctx.abrupt("return", {
                        error: true
                    });
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return function fetchTokenTransactions(address) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var transactions = ((/* unused pure expression or super */ null && (transactions_fetchTokenTransactions)));

// EXTERNAL MODULE: ./node_modules/date-fns/esm/getUnixTime/index.js
var esm_getUnixTime = __webpack_require__(99982);
// EXTERNAL MODULE: ./src/utils/getBlocksFromTimestamps.ts
var getBlocksFromTimestamps = __webpack_require__(12937);
// EXTERNAL MODULE: ./src/views/Info/utils/infoQueryHelpers.ts
var infoQueryHelpers = __webpack_require__(75126);
// EXTERNAL MODULE: ./src/config/constants/endpoints.ts
var endpoints = __webpack_require__(85906);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
;// CONCATENATED MODULE: ./src/state/info/queries/tokens/priceData.ts



function priceData_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query tokenPriceData {\n      ",
        "\n    }\n  "
    ]);
    priceData_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var getPriceSubqueries = function(tokenAddress, blocks) {
    return blocks.map(function(block) {
        return "\n      t".concat(block.timestamp, ':token(id:"').concat(tokenAddress, '", block: { number: ').concat(block.number, " }) { \n        derivedBNB\n      }\n      b").concat(block.timestamp, ': bundle(id:"1", block: { number: ').concat(block.number, " }) { \n        bnbPrice\n      }\n    ");
    });
};
/**
 * Price data for token and bnb based on block number
 */ var priceQueryConstructor = function(subqueries) {
    return (0,dist.gql)(priceData_templateObject(), subqueries);
};
var priceData_fetchTokenPriceData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(address, interval, startTimestamp) {
        var endTimestamp, timestamps, time, blocks, prices, tokenPrices, sortedTokenPrices, formattedHistory, i;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    endTimestamp = (0,esm_getUnixTime/* default */.Z)(new Date());
                    timestamps = [];
                    time = startTimestamp;
                    while(time <= endTimestamp){
                        timestamps.push(time);
                        time += interval;
                    }
                    _ctx.prev = 4;
                    _ctx.next = 7;
                    return (0,getBlocksFromTimestamps/* getBlocksFromTimestamps */.z)(timestamps, "asc", 500);
                case 7:
                    blocks = _ctx.sent;
                    if (!(!blocks || blocks.length === 0)) {
                        _ctx.next = 11;
                        break;
                    }
                    console.error("Error fetching blocks for timestamps", timestamps);
                    return _ctx.abrupt("return", {
                        error: false
                    });
                case 11:
                    _ctx.next = 13;
                    return (0,infoQueryHelpers/* multiQuery */.L)(priceQueryConstructor, getPriceSubqueries(address, blocks), endpoints/* INFO_CLIENT */.JY, 200);
                case 13:
                    prices = _ctx.sent;
                    if (prices) {
                        _ctx.next = 17;
                        break;
                    }
                    console.error("Price data failed to load");
                    return _ctx.abrupt("return", {
                        error: false
                    });
                case 17:
                    tokenPrices = [];
                    // Get Token prices in BNB
                    Object.keys(prices).forEach(function(priceKey) {
                        var timestamp = priceKey.split("t")[1];
                        // if its BNB price e.g. `b123` split('t')[1] will be undefined and skip BNB price entry
                        if (timestamp) {
                            var ref;
                            tokenPrices.push({
                                timestamp: timestamp,
                                derivedBNB: ((ref = prices[priceKey]) === null || ref === void 0 ? void 0 : ref.derivedBNB) ? parseFloat(prices[priceKey].derivedBNB) : 0,
                                priceUSD: 0
                            });
                        }
                    });
                    // Go through BNB USD prices and calculate Token price based on it
                    Object.keys(prices).forEach(function(priceKey) {
                        var timestamp = priceKey.split("b")[1];
                        // if its Token price e.g. `t123` split('b')[1] will be undefined and skip Token price entry
                        if (timestamp) {
                            var tokenPriceIndex = tokenPrices.findIndex(function(tokenPrice) {
                                return tokenPrice.timestamp === timestamp;
                            });
                            if (tokenPriceIndex >= 0) {
                                var ref;
                                var derivedBNB = tokenPrices[tokenPriceIndex].derivedBNB;
                                var ref1;
                                tokenPrices[tokenPriceIndex].priceUSD = parseFloat((ref1 = (ref = prices[priceKey]) === null || ref === void 0 ? void 0 : ref.bnbPrice) !== null && ref1 !== void 0 ? ref1 : 0) * derivedBNB;
                            }
                        }
                    });
                    sortedTokenPrices = orderBy_default()(tokenPrices, function(tokenPrice) {
                        return parseInt(tokenPrice.timestamp, 10);
                    });
                    formattedHistory = [];
                    // for each timestamp, construct the open and close price
                    for(i = 0; i < sortedTokenPrices.length - 1; i++){
                        formattedHistory.push({
                            time: parseFloat(sortedTokenPrices[i].timestamp),
                            open: sortedTokenPrices[i].priceUSD,
                            close: sortedTokenPrices[i + 1].priceUSD,
                            high: sortedTokenPrices[i + 1].priceUSD,
                            low: sortedTokenPrices[i].priceUSD
                        });
                    }
                    return _ctx.abrupt("return", {
                        data: formattedHistory,
                        error: false
                    });
                case 26:
                    _ctx.prev = 26;
                    _ctx.t0 = _ctx["catch"](4);
                    console.error("Failed to fetch price data for token ".concat(address), _ctx.t0);
                    return _ctx.abrupt("return", {
                        error: true
                    });
                case 30:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                26
            ]
        ]);
    }));
    return function fetchTokenPriceData(address, interval, startTimestamp) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var priceData = ((/* unused pure expression or super */ null && (priceData_fetchTokenPriceData)));

;// CONCATENATED MODULE: ./src/state/info/queries/tokens/poolsForToken.ts



function poolsForToken_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query poolsForToken($address: Bytes!, $blacklist: [String!]) {\n    asToken0: pairs(\n      first: 15\n      orderBy: trackedReserveBNB\n      orderDirection: desc\n      where: { totalTransactions_gt: 100, token0: $address, token1_not_in: $blacklist }\n    ) {\n      id\n    }\n    asToken1: pairs(\n      first: 15\n      orderBy: trackedReserveBNB\n      orderDirection: desc\n      where: { totalTransactions_gt: 100, token1: $address, token0_not_in: $blacklist }\n    ) {\n      id\n    }\n  }\n"
    ]);
    poolsForToken_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * Data for showing Pools table on the Token page
 */ var POOLS_FOR_TOKEN = (0,dist.gql)(poolsForToken_templateObject());
var poolsForToken_fetchPoolsForToken = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(address) {
        var data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return graphql/* infoClient.request */.dQ.request(POOLS_FOR_TOKEN, {
                        address: address,
                        blacklist: info/* TOKEN_BLACKLIST */.tE
                    });
                case 3:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", {
                        error: false,
                        addresses: data.asToken0.concat(data.asToken1).map(function(p) {
                            return p.id;
                        })
                    });
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Failed to fetch pools for token ".concat(address), _ctx.t0);
                    return _ctx.abrupt("return", {
                        error: true
                    });
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function fetchPoolsForToken(address) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var poolsForToken = ((/* unused pure expression or super */ null && (poolsForToken_fetchPoolsForToken)));

// EXTERNAL MODULE: ./src/state/info/actions.ts
var actions = __webpack_require__(44522);
;// CONCATENATED MODULE: ./src/state/info/hooks.ts














// Protocol hooks
var useProtocolData = function() {
    var protocolData = (0,es/* useSelector */.v9)(function(state) {
        return state.info.protocol.overview;
    });
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var setProtocolData = (0,react.useCallback)(function(data) {
        return dispatch((0,actions/* updateProtocolData */.Uo)({
            protocolData: data
        }));
    }, [
        dispatch
    ]);
    return [
        protocolData,
        setProtocolData
    ];
};
var useProtocolChartData = function() {
    var chartData = (0,es/* useSelector */.v9)(function(state) {
        return state.info.protocol.chartData;
    });
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var setChartData = (0,react.useCallback)(function(data) {
        return dispatch((0,actions/* updateProtocolChartData */.bj)({
            chartData: data
        }));
    }, [
        dispatch
    ]);
    return [
        chartData,
        setChartData
    ];
};
var useProtocolTransactions = function() {
    var transactions = (0,es/* useSelector */.v9)(function(state) {
        return state.info.protocol.transactions;
    });
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var setTransactions = (0,react.useCallback)(function(transactionsData) {
        return dispatch((0,actions/* updateProtocolTransactions */.oz)({
            transactions: transactionsData
        }));
    }, [
        dispatch
    ]);
    return [
        transactions,
        setTransactions
    ];
};
// Pools hooks
var useAllPoolData = function() {
    return (0,es/* useSelector */.v9)(function(state) {
        return state.info.pools.byAddress;
    });
};
var useUpdatePoolData = function() {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    return (0,react.useCallback)(function(pools) {
        return dispatch((0,actions/* updatePoolData */.Bp)({
            pools: pools
        }));
    }, [
        dispatch
    ]);
};
var useAddPoolKeys = function() {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    return (0,react.useCallback)(function(poolAddresses) {
        return dispatch((0,actions/* addPoolKeys */.iF)({
            poolAddresses: poolAddresses
        }));
    }, [
        dispatch
    ]);
};
var usePoolDatas = function(poolAddresses) {
    var allPoolData = useAllPoolData();
    var addNewPoolKeys = useAddPoolKeys();
    var untrackedAddresses = poolAddresses.reduce(function(accum, address) {
        if (!Object.keys(allPoolData).includes(address)) {
            accum.push(address);
        }
        return accum;
    }, []);
    (0,react.useEffect)(function() {
        if (untrackedAddresses) {
            addNewPoolKeys(untrackedAddresses);
        }
    }, [
        addNewPoolKeys,
        untrackedAddresses
    ]);
    var poolsWithData = poolAddresses.map(function(address) {
        var ref;
        return (ref = allPoolData[address]) === null || ref === void 0 ? void 0 : ref.data;
    }).filter(function(pool) {
        return pool;
    });
    return poolsWithData;
};
var usePoolChartData = function(address) {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var pool = (0,es/* useSelector */.v9)(function(state) {
        return state.info.pools.byAddress[address];
    });
    var chartData = pool === null || pool === void 0 ? void 0 : pool.chartData;
    var ref = (0,react.useState)(false), error = ref[0], setError = ref[1];
    (0,react.useEffect)(function() {
        var fetch = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, fetchError, data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return pools_chartData(address);
                        case 2:
                            ref = _ctx.sent;
                            fetchError = ref.error;
                            data = ref.data;
                            if (!fetchError && data) {
                                dispatch((0,actions/* updatePoolChartData */.jw)({
                                    poolAddress: address,
                                    chartData: data
                                }));
                            }
                            if (fetchError) {
                                setError(fetchError);
                            }
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!chartData && !error) {
            fetch();
        }
    }, [
        address,
        dispatch,
        error,
        chartData
    ]);
    return chartData;
};
var usePoolTransactions = function(address) {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var pool = (0,es/* useSelector */.v9)(function(state) {
        return state.info.pools.byAddress[address];
    });
    var transactions = pool === null || pool === void 0 ? void 0 : pool.transactions;
    var ref = (0,react.useState)(false), error = ref[0], setError = ref[1];
    (0,react.useEffect)(function() {
        var fetch = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, fetchError, data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return pools_transactions(address);
                        case 2:
                            ref = _ctx.sent;
                            fetchError = ref.error;
                            data = ref.data;
                            if (fetchError) {
                                setError(true);
                            } else {
                                dispatch((0,actions/* updatePoolTransactions */.oG)({
                                    poolAddress: address,
                                    transactions: data
                                }));
                            }
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!transactions && !error) {
            fetch();
        }
    }, [
        address,
        dispatch,
        error,
        transactions
    ]);
    return transactions;
};
// Tokens hooks
var useAllTokenData = function() {
    return (0,es/* useSelector */.v9)(function(state) {
        return state.info.tokens.byAddress;
    });
};
var useUpdateTokenData = function() {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    return (0,react.useCallback)(function(tokens) {
        dispatch((0,actions/* updateTokenData */.I6)({
            tokens: tokens
        }));
    }, [
        dispatch
    ]);
};
var useAddTokenKeys = function() {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    return (0,react.useCallback)(function(tokenAddresses) {
        return dispatch((0,actions/* addTokenKeys */.uP)({
            tokenAddresses: tokenAddresses
        }));
    }, [
        dispatch
    ]);
};
var useTokenDatas = function(addresses) {
    var allTokenData = useAllTokenData();
    var addNewTokenKeys = useAddTokenKeys();
    // if token not tracked yet track it
    addresses === null || addresses === void 0 ? void 0 : addresses.forEach(function(a) {
        if (!allTokenData[a]) {
            addNewTokenKeys([
                a
            ]);
        }
    });
    var tokensWithData = (0,react.useMemo)(function() {
        if (!addresses) {
            return undefined;
        }
        return addresses.map(function(a) {
            var ref;
            return (ref = allTokenData[a]) === null || ref === void 0 ? void 0 : ref.data;
        }).filter(function(token) {
            return token;
        });
    }, [
        addresses,
        allTokenData
    ]);
    return tokensWithData;
};
var useTokenData = function(address) {
    var ref;
    var allTokenData = useAllTokenData();
    var addNewTokenKeys = useAddTokenKeys();
    if (!address || !isAddress(address)) {
        return undefined;
    }
    // if token not tracked yet track it
    if (!allTokenData[address]) {
        addNewTokenKeys([
            address
        ]);
    }
    return (ref = allTokenData[address]) === null || ref === void 0 ? void 0 : ref.data;
};
var usePoolsForToken = function(address) {
    var dispatch = useAppDispatch();
    var token = useSelector(function(state) {
        return state.info.tokens.byAddress[address];
    });
    var poolsForToken = token.poolAddresses;
    var ref = useState(false), error = ref[0], setError = ref[1];
    useEffect(function() {
        var fetch = function() {
            var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee() {
                var ref, fetchError, addresses;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return fetchPoolsForToken(address);
                        case 2:
                            ref = _ctx.sent;
                            fetchError = ref.error;
                            addresses = ref.addresses;
                            if (!fetchError && addresses) {
                                dispatch(addTokenPoolAddresses({
                                    tokenAddress: address,
                                    poolAddresses: addresses
                                }));
                            }
                            if (fetchError) {
                                setError(fetchError);
                            }
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!poolsForToken && !error) {
            fetch();
        }
    }, [
        address,
        dispatch,
        error,
        poolsForToken
    ]);
    return poolsForToken;
};
var useTokenChartData = function(address) {
    var dispatch = useAppDispatch();
    var token = useSelector(function(state) {
        return state.info.tokens.byAddress[address];
    });
    var chartData = token.chartData;
    var ref = useState(false), error = ref[0], setError = ref[1];
    useEffect(function() {
        var fetch = function() {
            var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee() {
                var ref, fetchError, data;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return fetchTokenChartData(address);
                        case 2:
                            ref = _ctx.sent;
                            fetchError = ref.error;
                            data = ref.data;
                            if (!fetchError && data) {
                                dispatch(updateTokenChartData({
                                    tokenAddress: address,
                                    chartData: data
                                }));
                            }
                            if (fetchError) {
                                setError(fetchError);
                            }
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!chartData && !error) {
            fetch();
        }
    }, [
        address,
        dispatch,
        error,
        chartData
    ]);
    return chartData;
};
var useTokenPriceData = function(address, interval, timeWindow) {
    var dispatch = useAppDispatch();
    var token = useSelector(function(state) {
        return state.info.tokens.byAddress[address];
    });
    var priceData = token === null || token === void 0 ? void 0 : token.priceData[interval];
    var ref = useState(false), error = ref[0], setError = ref[1];
    // construct timestamps and check if we need to fetch more data
    var oldestTimestampFetched = token === null || token === void 0 ? void 0 : token.priceData.oldestFetchedTimestamp;
    var utcCurrentTime = getUnixTime(new Date()) * 1000;
    var startTimestamp = getUnixTime(startOfHour(sub(utcCurrentTime, timeWindow)));
    useEffect(function() {
        var fetch = function() {
            var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee() {
                var ref, data, fetchingError;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return fetchTokenPriceData(address, interval, startTimestamp);
                        case 2:
                            ref = _ctx.sent;
                            data = ref.data;
                            fetchingError = ref.error;
                            if (data) {
                                dispatch(updateTokenPriceData({
                                    tokenAddress: address,
                                    secondsInterval: interval,
                                    priceData: data,
                                    oldestFetchedTimestamp: startTimestamp
                                }));
                            }
                            if (fetchingError) {
                                setError(true);
                            }
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!priceData && !error) {
            fetch();
        }
    }, [
        address,
        dispatch,
        error,
        interval,
        oldestTimestampFetched,
        priceData,
        startTimestamp,
        timeWindow
    ]);
    return priceData;
};
var useTokenTransactions = function(address) {
    var dispatch = useAppDispatch();
    var token = useSelector(function(state) {
        return state.info.tokens.byAddress[address];
    });
    var transactions = token.transactions;
    var ref = useState(false), error = ref[0], setError = ref[1];
    useEffect(function() {
        var fetch = function() {
            var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee() {
                var ref, fetchError, data;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return fetchTokenTransactions(address);
                        case 2:
                            ref = _ctx.sent;
                            fetchError = ref.error;
                            data = ref.data;
                            if (fetchError) {
                                setError(true);
                            } else if (data) {
                                dispatch(updateTokenTransactions({
                                    tokenAddress: address,
                                    transactions: data
                                }));
                            }
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!transactions && !error) {
            fetch();
        }
    }, [
        address,
        dispatch,
        error,
        transactions
    ]);
    return transactions;
};


/***/ }),

/***/ 74472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H_": function() { return /* binding */ mapSwaps; },
/* harmony export */   "Hr": function() { return /* binding */ fetchChartData; },
/* harmony export */   "Iq": function() { return /* binding */ mapPairDayData; },
/* harmony export */   "_h": function() { return /* binding */ mapBurns; },
/* harmony export */   "k9": function() { return /* binding */ mapMints; },
/* harmony export */   "v5": function() { return /* binding */ mapDayData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var config_constants_info__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4003);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99982);
/* harmony import */ var state_info_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92157);







var mapMints = function(mint) {
    return {
        type: state_info_types__WEBPACK_IMPORTED_MODULE_1__/* .TransactionType.MINT */ .i.MINT,
        hash: mint.id.split("-")[0],
        timestamp: mint.timestamp,
        sender: mint.to,
        token0Symbol: mint.pair.token0.symbol,
        token1Symbol: mint.pair.token1.symbol,
        token0Address: mint.pair.token0.id,
        token1Address: mint.pair.token1.id,
        amountUSD: parseFloat(mint.amountUSD),
        amountToken0: parseFloat(mint.amount0),
        amountToken1: parseFloat(mint.amount1)
    };
};
var mapBurns = function(burn) {
    return {
        type: state_info_types__WEBPACK_IMPORTED_MODULE_1__/* .TransactionType.BURN */ .i.BURN,
        hash: burn.id.split("-")[0],
        timestamp: burn.timestamp,
        sender: burn.sender,
        token0Symbol: burn.pair.token0.symbol,
        token1Symbol: burn.pair.token1.symbol,
        token0Address: burn.pair.token0.id,
        token1Address: burn.pair.token1.id,
        amountUSD: parseFloat(burn.amountUSD),
        amountToken0: parseFloat(burn.amount0),
        amountToken1: parseFloat(burn.amount1)
    };
};
var mapSwaps = function(swap) {
    return {
        type: state_info_types__WEBPACK_IMPORTED_MODULE_1__/* .TransactionType.SWAP */ .i.SWAP,
        hash: swap.id.split("-")[0],
        timestamp: swap.timestamp,
        sender: swap.from,
        token0Symbol: swap.pair.token0.symbol,
        token1Symbol: swap.pair.token1.symbol,
        token0Address: swap.pair.token0.id,
        token1Address: swap.pair.token1.id,
        amountUSD: parseFloat(swap.amountUSD),
        amountToken0: parseFloat(swap.amount0In) - parseFloat(swap.amount0Out),
        amountToken1: parseFloat(swap.amount1In) - parseFloat(swap.amount1Out)
    };
};
var mapDayData = function(tokenDayData) {
    return {
        date: tokenDayData.date,
        volumeUSD: parseFloat(tokenDayData.dailyVolumeUSD),
        liquidityUSD: parseFloat(tokenDayData.totalLiquidityUSD)
    };
};
var mapPairDayData = function(pairDayData) {
    return {
        date: pairDayData.date,
        volumeUSD: parseFloat(pairDayData.dailyVolumeUSD),
        liquidityUSD: parseFloat(pairDayData.reserveUSD)
    };
};
// Common helper function to retrieve chart data
// Used for both Pool and Token charts
var fetchChartData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(getEntityDayDatas, address) {
        var chartEntries, error, skip, allFound, ref, data, fetchError, formattedDayDatas, availableDays, firstAvailableDayData, ref1, timestamp, ref2, latestLiquidityUSD, endTimestamp, dayOrdinal;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    chartEntries = [];
                    error = false;
                    skip = 0;
                    allFound = false;
                case 4:
                    if (allFound) {
                        _ctx.next = 16;
                        break;
                    }
                    _ctx.next = 7;
                    return getEntityDayDatas(skip, address);
                case 7:
                    ref = _ctx.sent;
                    data = ref.data;
                    fetchError = ref.error;
                    skip += 1000;
                    allFound = (data === null || data === void 0 ? void 0 : data.length) < 1000;
                    error = fetchError;
                    if (data) {
                        chartEntries = chartEntries.concat(data);
                    }
                    _ctx.next = 4;
                    break;
                case 16:
                    if (!(error || chartEntries.length === 0)) {
                        _ctx.next = 18;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: true
                    });
                case 18:
                    formattedDayDatas = chartEntries.reduce(function(accum, dayData) {
                        // At this stage we track unix day ordinal for each data point to check for empty days later
                        var dayOrdinal = parseInt((dayData.date / config_constants_info__WEBPACK_IMPORTED_MODULE_3__/* .ONE_DAY_UNIX */ .Bq).toFixed(0));
                        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, dayOrdinal, dayData), accum);
                    }, {});
                    availableDays = Object.keys(formattedDayDatas).map(function(dayOrdinal) {
                        return parseInt(dayOrdinal, 10);
                    });
                    firstAvailableDayData = formattedDayDatas[availableDays[0]];
                    ;
                    timestamp = (ref1 = firstAvailableDayData === null || firstAvailableDayData === void 0 ? void 0 : firstAvailableDayData.date) !== null && ref1 !== void 0 ? ref1 : config_constants_info__WEBPACK_IMPORTED_MODULE_3__/* .PCS_V2_START */ .Rr;
                    ;
                    latestLiquidityUSD = (ref2 = firstAvailableDayData === null || firstAvailableDayData === void 0 ? void 0 : firstAvailableDayData.liquidityUSD) !== null && ref2 !== void 0 ? ref2 : 0;
                    endTimestamp = (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(new Date());
                    while(timestamp < endTimestamp - config_constants_info__WEBPACK_IMPORTED_MODULE_3__/* .ONE_DAY_UNIX */ .Bq){
                        timestamp += config_constants_info__WEBPACK_IMPORTED_MODULE_3__/* .ONE_DAY_UNIX */ .Bq;
                        dayOrdinal = parseInt((timestamp / config_constants_info__WEBPACK_IMPORTED_MODULE_3__/* .ONE_DAY_UNIX */ .Bq).toFixed(0), 10);
                        if (!Object.keys(formattedDayDatas).includes(dayOrdinal.toString())) {
                            formattedDayDatas[dayOrdinal] = {
                                date: timestamp,
                                volumeUSD: 0,
                                liquidityUSD: latestLiquidityUSD
                            };
                        } else {
                            latestLiquidityUSD = formattedDayDatas[dayOrdinal].liquidityUSD;
                        }
                    }
                    return _ctx.abrupt("return", {
                        data: Object.values(formattedDayDatas),
                        error: false
                    });
                case 28:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchChartData(getEntityDayDatas, address) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 92157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ TransactionType; }
/* harmony export */ });
var TransactionType;
(function(TransactionType) {
    TransactionType[TransactionType["SWAP"] = 0] = "SWAP";
    TransactionType[TransactionType["MINT"] = 1] = "MINT";
    TransactionType[TransactionType["BURN"] = 2] = "BURN";
})(TransactionType || (TransactionType = {}));


/***/ }),

/***/ 58910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eh": function() { return /* binding */ Arrow; },
/* harmony export */   "Ob": function() { return /* binding */ PageButtons; },
/* harmony export */   "SS": function() { return /* binding */ Break; },
/* harmony export */   "_J": function() { return /* binding */ ClickableColumnHeader; },
/* harmony export */   "y6": function() { return /* binding */ TableWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(186);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4318);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding-top: 16px;\n  flex-direction: column;\n  gap: 16px;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 0.2em;\n  margin-bottom: 1.2em;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  padding: 0 20px;\n  :hover {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 1px;\n  background-color: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var ClickableColumnHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4dd460a5-0"
})(_templateObject());
var TableWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4dd460a5-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var PageButtons = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4dd460a5-2"
})(_templateObject2());
var Arrow = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4dd460a5-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var Break = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4dd460a5-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});


/***/ })

}]);